import axios from "../../config/axiosConfig";
import {
  CREATE_SALES_RETURN,
  DELETE_SALES_RETURN,
  GET_SALES_RETURNS,
  GET_SALES_RETURNS_PAGE,
  SALES_RETURN_REQUEST,
  SALES_RETURN_REQUEST_SUCCESS,
  SALES_RETURN_REQUEST_FAILURE,
  UPDATE_SALES_RETURN,
  SET_BILL_ORDERS
} from "../types";

export const getSalesReturnWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_RETURN_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Book_Id,Account_Id,Delivery_Account_Id,Grade_Id,Lot_Id'
      };
      return axios.get("/sales-return/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_SALES_RETURNS_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SALES_RETURN_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SALES_RETURN_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getSalesReturns = (include, finyear) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_RETURN_REQUEST });
      const { auth } = getState();
      const fin = finyear || auth.finyear; 
      let params = { finyearId: fin?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      if (include) {
        params = { ...params, include };
      }
      return axios.get("/sales-return/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_SALES_RETURNS, payload: response.data?.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SALES_RETURN_REQUEST_FAILURE, error: error.message });
      }); 
    } catch (error) {
      console.error(error);
      dispatch({ type: SALES_RETURN_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getSalesReturnByRange = (bookId, billId, from, to, finyear) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      const fin = finyear || auth.finyear; 
      let params = {
        finyearId: fin?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        bookId, billId, from, to
      };
      
      const response = await axios.get("/sales-return/getAll", { params });
      return response.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getSalesReturnById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_RETURN_REQUEST });
    
      return axios.get(`/sales-return/get/${id}`).then((response) => {
        dispatch({ type: SALES_RETURN_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SALES_RETURN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SALES_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const createSalesReturn = (purchaseBillReturn, finyear) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      const fin = finyear || auth.finyear; 
      dispatch({ type: SALES_RETURN_REQUEST });
      const newSalesReturn = {
        ...purchaseBillReturn
      };
      return axios.post("/sales-return/add", newSalesReturn,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: fin?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_SALES_RETURN, payload: response.data });
        } else {
          dispatch({
            type: SALES_RETURN_REQUEST_FAILURE,
            error: "Sales return create failed.",
          });
          throw new Error("Sales return create failed.");
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SALES_RETURN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SALES_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateSalesReturn = (id, data, finyear) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_RETURN_REQUEST });
      const { auth } = getState();
      const fin = finyear || auth.finyear; 
      return axios.put("/sales-return/update", { id, data },
        { params: {
          userId: auth.user?.id,
          companyId: data.Company_Id || auth.company?.id,
          finyearId: data.Finyear_Id || fin?.id,
          customerId: data.Customer_Id || auth?.user?.Customer_Id,
        }}
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_SALES_RETURN,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: SALES_RETURN_REQUEST_FAILURE,
            error: "Sales return update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SALES_RETURN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SALES_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteSalesReturn = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_RETURN_REQUEST });
      return axios.delete(`/sales-return/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_SALES_RETURN, id: id });
          const include = ['id', 'Invoice_No', 'Challan_No', 'Book_Id', 'Date', 'Account_Id', 'Original_Invoice_No', 'Delivery_Account_Id', 'Grade_Id', 'Lot_Id', 'Net_Total', 'Ack_No'].join(',');
          const searchCols = ['Invoice_No'].join(',');
          const { inventory: { salesReturn: { page, pageSize, search, where } = {} } } = getState();
          dispatch(getSalesReturnWithPagination(page, pageSize, include, search, searchCols, where, true));
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SALES_RETURN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SALES_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getSalesReturnBillOrders = (id, bookId) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_RETURN_REQUEST });
      const { auth } = getState();
      let params = {
        customerId: auth?.user?.Customer_Id,
        bookId,
        id
      };
      
      if (!auth?.company?.Common_Order) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get(`/sales-return/getRemainingBillOrders`, { params }).then((response) => {
        dispatch({
          type: SET_BILL_ORDERS,
          payload: response.data || [],
        });
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SALES_RETURN_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SALES_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const generateEInvoiceSalesReturn = (id, finyear) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_RETURN_REQUEST });
      const { auth } = getState();
      const fin = finyear || auth.finyear; 
      
      return axios.get(`/sales-return/generate-e-invoice/${id}`,{
        params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: fin?.id, customerId: auth?.user?.Customer_Id }
      }).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_SALES_RETURN,
            payload: { id, data: response.data },
          });
        }
        return response;
      }).catch((error) => {
        console.log('generate eway bill error',error);
        dispatch({ type: SALES_RETURN_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SALES_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const cancelEInvoiceSalesReturn = (id, data, finyear) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_RETURN_REQUEST });
      const { auth } = getState();
      const fin = finyear || auth.finyear; 
      return axios.post(`/sales-return/cancel-e-invoice/${id}`, data, {
        params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: fin?.id, customerId: auth?.user?.Customer_Id }
      }).then((response) => {
        if (response.data) {
          // dispatch({ type: CANCEL_EWAY_BILL, id: id });
          dispatch({
            type: UPDATE_SALES_RETURN,
            payload: { id, data: response.data },
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SALES_RETURN_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SALES_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deletedEInvoiceSalesReturn = (finyear) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_RETURN_REQUEST });
      const { auth } = getState();
      const fin = finyear || auth.finyear; 
      let params = { finyearId: fin?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      return axios.get("/sales-return/delete-e-invoice-bills", { params }).then((response) => {
        if (response.data) {
          return response.data;
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SALES_RETURN_REQUEST_FAILURE, error: error.message });
      }); 
    } catch (error) {
      console.error(error);
      dispatch({ type: SALES_RETURN_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const sendMailSaleReturn = (mailData, finyear) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_RETURN_REQUEST });
      const { auth } = getState();
      const fin = finyear || auth.finyear; 
      
      // Create FormData to handle file attachment
      const formData = new FormData();
      formData.append('to', mailData.to);
      formData.append('templateId', mailData.templateId);
      formData.append('salesReturnId', mailData.salesReturnId);
      formData.append('finyearId', fin?.id);
      formData.append('companyId', auth.company?.id);
      formData.append('customerId', auth?.user?.Customer_Id);
      formData.append('recipientType', mailData.recipientType || 'custom');
      formData.append('moduleName', mailData.moduleName);
      
      // Add PDF attachment if exists
      if (mailData.pdfAttachment) {
        formData.append('attachment', mailData.pdfAttachment, `sales_return_${mailData.salesReturnId}.pdf`);
      }
      // console.log('formData>>',formData);
      return axios.post("/sales-return/mail-send", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        if (response.data) {
          dispatch({ type: SALES_RETURN_REQUEST_SUCCESS });
          return response.data;
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ 
          type: SALES_RETURN_REQUEST_FAILURE, 
          error: error.message 
        });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ 
        type: SALES_RETURN_REQUEST_FAILURE, 
        error: error.message 
      });
      throw error;
    }
  };
};

export const sendWhatsappSaleReturn = (whatsappData, finyear) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_RETURN_REQUEST });
      const { auth } = getState();
      const fin = finyear || auth.finyear; 
      
      // Create FormData to handle file attachment
      const formData = new FormData();
      formData.append('to', whatsappData.to);
      formData.append('templateId', whatsappData.templateId);
      formData.append('salesReturnId', whatsappData.salesReturnId);
      formData.append('finyearId', fin?.id);
      formData.append('companyId', auth.company?.id);
      formData.append('customerId', auth?.user?.Customer_Id);
      formData.append('recipientType', whatsappData.recipientType || 'custom');
      
      // Add PDF attachment if exists
      if (whatsappData.pdfAttachment) {
        formData.append('attachment', whatsappData.pdfAttachment, `sales_return_${whatsappData.salesReturnId}.pdf`);
      }
      // console.log('formData>>',formData);
      return axios.post("/sales-return/whatsapp-send", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        if (response.data) {
          dispatch({ type: SALES_RETURN_REQUEST_SUCCESS });
          return response.data;
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ 
          type: SALES_RETURN_REQUEST_FAILURE, 
          error: error.message 
        });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ 
        type: SALES_RETURN_REQUEST_FAILURE, 
        error: error.message 
      });
      throw error;
    }
  };
};

export const getDeliChallanReturnByChallanNo = (challanNo, bookId, salesId, finyear) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      const fin = finyear || auth.finyear; 
      let params = {
        finyearId: fin?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        challanNo,
        bookId,
        salesId
      };
      const res = await axios.get(`/sales-return/get-delichallan-return-by-challan-no`, { params });
      return res?.data;
    } catch (error) {
      console.error(error);
    }
  };
};

export const getSalesBillByInvoiceNoInSalesReturn = (invoiceNo, bookId, finyear) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      const fin = finyear || auth.finyear; 

      let params = {
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        finyearId: fin?.id,
        invoiceNo,
        bookId,
      };
      const res = await axios.get(`/sales-return/get-sale-bill-by-invoice-no`, { params });
      return res?.data;
    } catch (error) {
      console.error(error);
    }
  };
};

export const getSalesBillsListByInvoiceNoInSalesReturn = (invNo, bookId) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        invoiceNo: invNo,
        bookId: bookId,
      };
      return axios.get(`/sales-return/get-all-sale-bill-by-invoice-no`, { params }).then((response) => {
        return response?.data;
      }).catch((error) => {
        console.error(error); 
      });
    } catch (error) {
      console.error(error);
    }
  };
};